// Pdf Template Item Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class PdfTemplateItem extends Component {
  static get propTypes () {
    return {
      title: PropTypes.string,
      active: PropTypes.bool,
      selected: PropTypes.bool,
      onClick: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      title: '',
      active: false,
      selected: false,
      onClick: null
    }
  }

  render () {
    const _className = classnames('pdftemplateitem', {
      active: this.props.selected
    })
    return (
      <div className={_className} onClick={this._onClick.bind(this)}>
        <div className='cont'>
          <div className='itemleft'>
            <h4 className='itemtitle'>
              <IntlMessage ident={this.props.title} />
            </h4>
            <span className='status'>
              {this.props.active ? (
                <IntlMessage ident='setting.pdfTemplate.activeLabel' />
              ) : (
                <IntlMessage ident='setting.pdfTemplate.inactiveLabel' />
              )}
            </span>
          </div>
          <div className='itemright'>
            <IconButton
              icon='pdftemplate-edit'
              size='normal'
              className='template'
              canHover={false}
            />
          </div>
        </div>
      </div>
    )
  }

  _onClick (ev) {
    ev.preventDefault()

    if (this.props.onClick) {
      this.props.onClick()
    }
  }
}

export default PdfTemplateItem
